export const frHero = {
  badge: 'Plateforme de commande professionnelle',
  title_part1: 'Prenez le contrôle de vos',
  title_part2: ' commandes en ligne',
  subtitle:
    "Lewouhmart unifie catalogue produits, stock, paiements et livraisons dans une plateforme sécurisée et prête pour l'international.",
  cta_primary: 'Commencer',
  cta_secondary: 'Démo en direct',
  feature_iam_title: 'Identité & sécurité',
  feature_iam_body:
    "Accès par rôles, MFA pour les employés et sécurité transactionnelle dès la conception.",
  feature_global_title: 'Prêt pour le monde',
  feature_global_body:
    'Multi-langue et multi-devise disponibles dès le départ.',
  feature_stock_title: 'Stock fiable',
  feature_stock_body:
    'Gestion de stock sûre en concurrence avec calcul de profit précis.',
  carousel_section_label: 'Points forts de la plateforme',
  carousel_iam_title: 'IAM sécurisé pour toute votre équipe',
  carousel_iam_subtitle:
    "Les employés se connectent avec MFA et accès par rôles, tandis que les clients utilisent un simple couple e-mail + mot de passe.",
  carousel_global_title: 'Prêt pour le monde dès le premier jour',
  carousel_global_subtitle:
    'Servez vos clients dans plusieurs langues et devises, avec des préférences qui suivent les appareils.',
  carousel_stock_title: 'Stock et exécution fiables',
  carousel_stock_subtitle:
    'Un contrôle de stock sûr en concurrence et un suivi des livraisons pour des opérations prévisibles.',
} as const;

export const frAuth = {
  tab_sign_in: 'Connexion',
  tab_register: 'Créer un compte',
  sign_in_title: 'Se connecter à Lewouhmart',
  sign_in_subtitle:
    'Utilisez votre e-mail et votre mot de passe pour accéder à vos commandes et aux paramètres de votre compte.',
  sign_in_customer_hint:
    'Connectez-vous avec l’e-mail et le mot de passe de votre compte client.',
  register_title: 'Créer votre compte client',
  register_subtitle:
    'Utilisez votre e-mail et un mot de passe robuste. Nous vous demanderons de vérifier votre e-mail lors de la première connexion.',
  email_label: 'Adresse e-mail',
  password_label: 'Mot de passe',
  password_placeholder: 'Au moins 8 caractères',
  sign_in_button: 'Continuer',
  register_button: 'Créer le compte',
  register_invite_applied:
    'Vous créez un compte avec le code de parrainage {{code}}. L’éligibilité est vérifiée lors de votre première commande qualifiante payée.',
  register_invite_code_label: 'Code de parrainage (facultatif)',
  register_invite_code_placeholder: "Code d'invitation",
  register_invite_code_hint:
    'Laissez vide si vous n’en avez pas. Un code présent dans le lien d’invitation (?ref=…) est repris automatiquement.',
  register_apply_referral_checkbox: 'Utiliser un code de parrainage',
  register_referral_required_when_checked:
    'Saisissez un code de parrainage ou décochez la case pour continuer sans code.',
  mfa_title: 'Saisissez votre code de sécurité',
  mfa_body_intro: 'Nous avons envoyé un code à 6 chiffres à',
  mfa_body_outro: 'Saisissez-le pour terminer la connexion.',
  mfa_button: 'Vérifier et continuer',
  mfa_resend: 'Renvoyer le code',
  mfa_resend_sending: 'Envoi…',
  mfa_resend_wait: 'Renvoyer le code dans {{seconds}}s',
  mfa_resend_failed: 'Impossible de renvoyer le code.',
  mfa_back_to_sign_in: 'Retour à la connexion',
  mfa_resend_policy:
    'Vous pouvez renvoyer le code jusqu’à 3 fois par heure. Si l’e-mail n’arrive toujours pas, vérifiez les courriers indésirables ou la configuration e-mail du serveur (SES).',
  signed_in_title: 'Vous êtes connecté',
  signed_in_body:
    'Vos préférences de langue et de devise sont synchronisées avec votre profil. Les futures sessions et autres clients (comme une application mobile) pourront les réutiliser.',
  signed_in_label: 'Connecté en tant que',
  signed_in_logout: 'Se déconnecter',
  register_success_prefix: 'Compte créé pour',
  register_success_suffix:
    'Nous vous avons envoyé un e-mail de vérification. Veuillez le confirmer dans votre boîte de réception avant de vous connecter.',
  register_success_banner_title: 'Vérifiez votre boîte mail — dernière étape',
  register_form_locked_note:
    'Ce formulaire est verrouillé tant que vous n’avez pas vérifié votre e-mail. Vous pouvez fermer cet onglet après avoir ouvert le message que nous avons envoyé.',
  verify_email_resent:
    'Votre adresse e-mail n’est pas encore vérifiée. Nous venons de vous renvoyer un e-mail de vérification. Veuillez le confirmer avant de réessayer.',
  verify_email_heading: 'Vérifiez votre adresse e-mail',
  verify_email_loading: 'Vérification de votre e-mail, veuillez patienter…',
  verify_email_success:
    'Votre e-mail a été vérifié avec succès. Vous pouvez maintenant vous connecter.',
  verify_email_error:
    "Nous n'avons pas pu vérifier votre e-mail. Le lien a peut-être expiré ou déjà été utilisé.",
  verify_email_missing_token:
    'Le lien de vérification est invalide. Veuillez utiliser le lien reçu par e-mail ou en demander un nouveau.',
  verify_email_back_to_signin: 'Retour à la connexion',
  forgot_link: 'Mot de passe oublié ?',
  forgot_title: 'Réinitialiser votre mot de passe',
  forgot_subtitle:
    'Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
  forgot_submit: 'Envoyer le lien de réinitialisation',
  forgot_sending: 'Envoi…',
  forgot_success:
    'Si un compte existe, un lien de réinitialisation a été envoyé.',
  forgot_error: "Impossible d'envoyer l’e-mail de réinitialisation.",
  reset_title: 'Choisissez un nouveau mot de passe',
  reset_subtitle: 'Définissez un nouveau mot de passe pour votre compte Lewouhmart.',
  reset_password_label: 'Nouveau mot de passe',
  reset_confirm_password_label: 'Confirmez le nouveau mot de passe',
  reset_submit: 'Enregistrer le nouveau mot de passe',
  reset_saving: 'Enregistrement…',
  reset_mismatch: 'Les mots de passe ne correspondent pas.',
  reset_invalid_link:
    'Ce lien de réinitialisation est invalide. Veuillez utiliser le lien reçu par e-mail.',
  reset_success:
    'Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.',
  reset_error: 'Impossible de réinitialiser le mot de passe.',
  reset_back_to_signin: 'Retour à la connexion',
  account_deleted_notice:
    'Votre compte a été supprimé. Nous sommes désolés de vous voir partir.',
  email_placeholder: 'vous@exemple.com',
  security_block_title: 'Sécurité du compte',
  security_block_loading: 'Confirmation…',
  security_block_success:
    'Votre compte équipe a été bloqué. Les sessions actives ont été terminées. Contactez un administrateur pour rétablir l’accès.',
  security_block_error_generic: 'Lien invalide, déjà utilisé ou expiré.',
  security_block_missing_token: 'Aucun jeton de sécurité fourni.',
  security_block_back_sign_in: 'Retour à la connexion',
} as const;

export const frLayout = {
  app_name: 'Lewouhmart',
  app_tagline: 'Commerce & gestion des commandes',
  footer_right:
    'Conçu pour la fiabilité, la concurrence et la croissance internationale.',
} as const;

export const frAccount = {
  title: 'Mon compte',
  subtitle:
    'Gérez votre profil, la sécurité de la connexion et votre adresse de livraison par défaut.',
  sign_in_required: 'Veuillez vous connecter pour afficher votre compte.',
  profile_section_title: 'Contact et livraison',
  profile_section_subtitle:
    'Utilisé sur les commandes, factures et étiquettes d’expédition.',
  field_full_name: 'Nom complet',
  field_phone: 'Téléphone',
  field_street: 'Adresse',
  field_city: 'Ville',
  field_postal_code: 'Code postal',
  field_country: 'Pays',
  readonly_name_label: 'Nom',
  readonly_phone_label: 'Téléphone',
  readonly_address_label: 'Adresse',
  not_set: 'Non renseigné',
  save_button: 'Enregistrer les modifications',
  cancel_button: 'Annuler',
  edit_button: 'Modifier',
  status_label: 'Statut',
  status_verified: 'Vérifié',
  status_pending: 'En attente de vérification',
  email_label: 'E-mail du compte',
  load_error: 'Impossible de charger les informations du compte.',
  save_success: 'Profil mis à jour avec succès.',
  save_error: 'Impossible d’enregistrer le profil.',
  security_section_title: 'Sécurité',
  current_password_label: 'Mot de passe actuel',
  new_password_label: 'Nouveau mot de passe',
  confirm_password_label: 'Confirmez le nouveau mot de passe',
  password_mismatch: 'Les mots de passe ne correspondent pas.',
  password_save_button: 'Mettre à jour le mot de passe',
  password_saving_label: 'Mise à jour…',
  password_change_success: 'Mot de passe mis à jour avec succès.',
  password_change_error: 'Impossible de modifier le mot de passe.',
  password_open_button: 'Changer le mot de passe',
  delete_section_title: 'Fermer votre compte',
  delete_section_intro:
    'La suppression retire l’accès à ce profil. Les dossiers de commandes peuvent être conservés pour des besoins légaux ou opérationnels, mais ne seront plus associés à vous.',
  delete_email_retention:
    'Pour limiter la fraude et les abus de parrainage, nous conservons une forme normalisée de votre adresse e-mail sans limite de durée. Si vous vous inscrivez à nouveau avec la même adresse, un nouveau profil est créé sans lien avec les commandes ou le parrainage passés.',
  delete_phrase_hint_before: 'Saisissez exactement :',
  delete_password_label: 'Mot de passe actuel (obligatoire)',
  delete_confirm_label: 'Saisissez cette phrase pour confirmer',
  delete_confirm_placeholder: 'I-want-to-delete-account',
  delete_confirm_mismatch:
    'Saisissez exactement la phrase I-want-to-delete-account.',
  delete_password_required: 'Saisissez votre mot de passe actuel.',
  delete_submit: 'Supprimer mon compte',
  delete_submitting: 'Suppression…',
  delete_error: 'Impossible de supprimer le compte. Vérifiez votre mot de passe.',
  delete_success_redirect: 'Votre compte a été supprimé.',
  retention_offer_percent:
    'Si vous restez : {{percent}}% sur le sous-total marchandises de votre prochaine commande (une fois, appliqué au paiement).',
  retention_accepted_with_percent:
    'Merci de rester avec nous. Votre prochaine commande inclura une remise unique de {{percent}}% sur le sous-total marchandises, affichée au paiement et sur votre reçu.',
  retention_banner_title: 'Remise de fidélité débloquée',
  retention_banner_dismiss: 'Fermer',
  retention_cancel: 'Annuler',
  retention_email_cooldown_notice:
    'Cette adresse e-mail a récemment utilisé l’offre de maintien ou la remise unique liée à la suppression. L’offre reste indisponible jusqu’au {{date}} (UTC).',
  sidebar_overview: 'Compte',
  sidebar_orders: 'Commandes',
  sidebar_referrals: 'Parrainage',
  sidebar_security: 'Sécurité',
  sidebar_notifications: 'Notifications',
  orders_title: 'Mes commandes',
  orders_subtitle: 'Suivez le statut et l’historique de vos commandes.',
  orders_search_placeholder: 'Rechercher n° de commande ou article',
  orders_empty: 'Aucune commande pour le moment.',
  orders_empty_filtered: 'Aucune commande ne correspond aux filtres.',
  order_id: 'Commande',
  payment_id: 'ID de paiement',
  payment_id_none: '—',
  preorder_payments_heading: 'Paiements carte (précommande)',
  preorder_deposit_payment_label: 'ID du paiement d’acompte',
  preorder_balance_payment_label: 'ID du paiement du solde',
  preorder_balance_payments_label: 'IDs des débits de solde',
  preorder_balance_payment_index: '{{n}}.',
  preorder_balance_payment_pending: 'Pas encore débité (après libération)',
  items: 'Articles',
  eta: 'Livraison estimée',
  eta_days: '{{days}} jours',
  delivery_window_from: 'Du',
  delivery_window_until: 'Au',
  order_history: 'Historique de commande',
  cancel_order: 'Annuler la commande',
  order_collapsed_hint:
    'Commande clôturée réduite. Développez pour voir les détails.',
  orders_pagination_info: 'Page {{page}} sur {{totalPages}}',
  orders_load_error: 'Impossible de charger les commandes.',
  orders_cancel_error: 'Impossible d’annuler la commande.',
  order_receipt_download: 'Reçu (PDF)',
  order_receipt_error: 'Impossible de télécharger le reçu.',
  order_event_update: 'Mise à jour',
  order_event_change: '{{from}} → {{to}}',
  saving_label: 'Enregistrement…',
  order_status_PENDING: 'En attente',
  order_status_PAID: 'Payée',
  order_status_SHIPPED: 'Expédiée',
  order_status_DELIVERED: 'Livrée',
  order_status_CLOSED: 'Clôturée',
  order_status_CANCELLED: 'Annulée',
  order_status_UNREACHABLE: 'Injoignable',
  order_status_DAMAGED: 'Endommagée',
  order_status_INVESTIGATING: 'En cours d’analyse',
  order_status_FAULT_EMPLOYEE: 'Faute employé',
  order_status_FAULT_CUSTOMER: 'Faute client',
  order_status_RESHIP_PENDING: 'Réexpédition en attente',
  order_status_RESHIPPED: 'Réexpédiée',
  referrals_copied: 'Copié !',
  referrals_status_pending: 'En attente de commande éligible',
  referrals_status_qualified: 'Terminé',
  referrals_status_rejected: 'Non éligible',
  referrals_signup_only_note:
    'Les liens et codes de parrainage s’utilisent à la création du compte—pas au paiement. Si vous vous êtes inscrit avec le lien d’un ami, c’est déjà lié à votre profil ; vous ne le saisissez pas à nouveau à la caisse.',
  referrals_pending_hint:
    'Aucune validation manuelle n’est requise. Dès que votre première commande est payée et atteint le minimum ({{min}} USD), le parrainage est finalisé automatiquement. Vous ne saisissez jamais un code de parrainage au moment du paiement.',
  referrals_qualified_hint:
    'Votre parrainage est terminé : inscription avec le lien d’un ami et première commande éligible payée. Les montants affichés sont les objectifs du programme—ils ne s’appliquent pas comme champ supplémentaire au paiement. La façon dont les récompenses sont versées (crédit, virement, etc.) dépend de la boutique ; contactez le support si vous attendiez une remise immédiate sur la commande.',
  referrals_rejected_hint:
    'Ce parrainage n’a pas pu être pris en compte. Contactez le support pour toute question.',
  referrals_subtitle_ended:
    'Ce programme de parrainage n’accepte plus de nouveaux participants. Votre historique figure ci-dessous.',
  referrals_program_ended_banner:
    'Le programme de parrainage n’accepte plus de nouveaux participants. Votre historique est conservé. Les parrainages en cours peuvent encore se finaliser lorsque les commandes éligibles sont payées.',
  referrals_program_ended_no_new_links:
    'Les nouveaux liens d’invitation sont désactivés. Il s’agissait de votre code pendant la période active.',
  referrals_disabled: 'Le programme de parrainage n’est pas actif pour le moment.',
} as const;

export const frHeader = {
  brand_name: 'Lewouhmart',
  brand_tagline: 'Commerce & gestion des commandes',
  nav_home: 'Accueil',
  nav_cart: 'Panier',
  nav_admin_dashboard: 'Tableau de bord',
  nav_admin_employees: 'Employés',
  nav_admin_customers: 'Clients',
  nav_products: 'Produits',
  nav_products_catalog: 'Catalogue',
  nav_products_inventory: 'Stock & achats',
  logged_in_as: 'Connecté en tant que',
  account_button: 'Compte',
  logout_button: 'Déconnexion',
} as const;

export const frFooter = {
  copyright: 'Lewouhmart. Tous droits réservés.',
  footer_right:
    'Conçu pour la fiabilité, la concurrence et la croissance internationale.',
  workspace_internal: 'Espace équipe.',
  workspace_open_storefront: 'Site client',
  customer_heading: 'Client',
  link_home: 'Accueil',
  link_products: 'Produits',
  link_cart: 'Panier',
  link_track_orders: 'Suivre les commandes',
  link_feedback_complaints: 'Avis et réclamations',
  link_about: 'À propos',
  link_cookie_settings: 'Paramètres cookies',
  ops_heading: 'Opérations',
  link_employee_signin: 'Connexion employé',
  ops_live_workflow: 'Flux de commandes en direct',
  ops_incidents: 'Incidents et résolution',
  ops_analytics: 'Analyses par pays',
  support_heading: 'Support & mentions légales',
  terms: 'Conditions d’utilisation',
  privacy: 'Politique de confidentialité',
  storefront_tagline: 'Conçu pour des commandes fiables à grande échelle.',
  storefront_about:
    'Plateforme mondiale de commandes, inventaire et suivi des livraisons pour les équipes commerce.',
} as const;

export const frAdmin = {
  sidebar_overview: 'Vue d’ensemble',
  sidebar_employees: 'Employés',
  sidebar_customers: 'Clients',
  sidebar_customer_archives: 'Comptes supprimés (archives)',
  sidebar_products: 'Produits',
   sidebar_categories: 'Catégories',
   sidebar_inventory: 'Stock',
   sidebar_hero: 'Bannière d’accueil',
  sidebar_landing_promotion: 'Promotion d’accueil',
  sidebar_mail_routing: 'Expéditeurs e-mail',
   sidebar_group_users: 'Utilisateurs',
   sidebar_group_products: 'Produits',
   sidebar_group_settings: 'Paramètres',
   sidebar_group_site_settings: 'Paramètres du site',
   sidebar_group_system: 'Paramètres système',
  sidebar_suppliers: 'Fournisseurs',
  sidebar_roles: 'Rôles',
  suppliers_title: 'Fournisseurs',
  suppliers_subtitle:
    'Gérez vos fournisseurs. Seuls les employés peuvent créer et modifier des fournisseurs ; les fournisseurs ne se connectent pas.',
  suppliers_search: 'Rechercher par nom, e-mail ou téléphone',
  suppliers_active_only: 'Actifs uniquement',
  suppliers_new: 'Nouveau fournisseur',
  suppliers_hide_form: 'Masquer le formulaire',
  suppliers_name: 'Nom',
  suppliers_email: 'E-mail',
  suppliers_phone: 'Téléphone',
  suppliers_country: 'Pays',
  suppliers_country_placeholder: 'Choisir un pays',
  suppliers_city: 'Ville',
  suppliers_address: 'Adresse',
  suppliers_notes: 'Notes',
  suppliers_save: 'Enregistrer le fournisseur',
  suppliers_update: 'Modifier le fournisseur',
  suppliers_loading: 'Chargement des fournisseurs…',
  suppliers_empty: 'Aucun fournisseur trouvé.',
  suppliers_col_name: 'Nom',
  suppliers_col_email: 'E-mail',
  suppliers_col_phone: 'Téléphone',
  suppliers_col_country: 'Pays',
  suppliers_col_city: 'Ville',
  suppliers_col_status: 'Statut',
  suppliers_status_active: 'Actif',
  suppliers_status_inactive: 'Inactif',
  suppliers_edit: 'Modifier',
  suppliers_activate: 'Activer',
  suppliers_deactivate: 'Désactiver',
  suppliers_load_error: 'Impossible de charger les fournisseurs.',
  suppliers_save_error: "Impossible d'enregistrer le fournisseur.",
  suppliers_update_error: 'Impossible de mettre à jour le fournisseur.',
  categories_title: 'Catégories',
  categories_subtitle: 'Gérer les catégories de produits pour la boutique et la page d’accueil.',
  categories_count: 'catégories',
  categories_add: 'Ajouter une catégorie',
  categories_name: 'Nom',
  categories_slug: 'Slug (URL)',
  categories_slug_placeholder: 'ex. legumes',
  categories_description: 'Description',
  categories_sort_order: 'Ordre',
  categories_list: 'Toutes les catégories',
  categories_loading: 'Chargement…',
  categories_empty: 'Aucune catégorie pour l’instant.',
  categories_active: 'Actif',
  categories_update: 'Modifier',
  categories_create: 'Créer',
  categories_confirm_delete: 'Supprimer cette catégorie ?',
  categories_yes: 'Oui',
  categories_no: 'Non',
  categories_load_error: 'Impossible de charger les catégories.',
  categories_save_error: 'Impossible d’enregistrer la catégorie.',
  categories_delete_error: 'Impossible de supprimer la catégorie.',
  categories_duplicate_slug:
    'Une catégorie avec ce slug d’URL existe déjà. Modifiez le slug ou le nom.',
  categories_duplicate_generic:
    'Une catégorie avec ce nom ou ce slug d’URL existe déjà. Modifiez les valeurs et réessayez.',
  categories_field_name_taken: 'Ce nom est déjà utilisé par une autre catégorie.',
  categories_field_slug_taken: 'Ce slug d’URL est déjà utilisé par une autre catégorie.',
  categories_unique_hint: 'Le nom et le slug d’URL de chaque catégorie doivent être uniques.',
  hero_title: 'Carrousel d’accueil',
  hero_subtitle: 'Gérer les diapositives pleine page de la page d’accueil publique.',
  hero_form_edit: 'Modifier la diapositive',
  hero_form_new: 'Nouvelle diapositive',
  hero_label_image: 'Image',
  hero_label_headline: 'Titre',
  hero_label_subheadline: 'Sous-titre',
  hero_label_button_label: 'Libellé du bouton',
  hero_label_button_link: 'Lien du bouton',
  hero_label_sort_order: 'Ordre',
  hero_label_active: 'Actif',
  hero_btn_clear: 'Effacer',
  hero_btn_save: 'Enregistrer',
  hero_btn_add_slide: 'Ajouter une diapositive',
  hero_existing_slides: 'Diapositives existantes',
  hero_loading: 'Chargement…',
  hero_empty: 'Aucune diapositive. Créez la première à gauche.',
  hero_order: 'ordre',
  hero_button: 'Bouton',
  hero_link: 'Lien',
  hero_btn_edit: 'Modifier',
  hero_active: 'Actif',
  hero_inactive: 'Inactif',
  hero_btn_delete: 'Supprimer',
  hero_confirm_delete: 'Supprimer cette diapositive ?',
  hero_error_headline: 'Le titre est requis',
  hero_error_upload: 'Veuillez télécharger une image',
  hero_shop_now_default: 'Acheter',
  dashboard_title: 'Espace administrateur',
  dashboard_subtitle:
    'Surveillez votre équipe et votre base clients depuis un seul endroit.',
  dashboard_card_employees_title: 'Employés',
  dashboard_card_employees_body:
    'Vue d’ensemble de tous les comptes du personnel avec MFA appliqué.',
  dashboard_card_customers_title: 'Clients',
  dashboard_card_customers_body:
    'Clients enregistrés avec adresses e-mail vérifiées.',
  dashboard_card_security_title: 'Sécurité',
  dashboard_card_security_body:
    'Les employés s’authentifient toujours avec un code supplémentaire par e-mail.',

  employees_title: 'Employés',
  employees_subtitle:
    'Invitez des membres du personnel dans Lewouhmart et gérez leurs informations de base.',
  employees_invite_title: 'Inviter un nouvel employé',
  employees_invite_email_label: 'E-mail professionnel',
  employees_invite_name_label: 'Nom complet',
  employees_invite_role_label: 'Intitulé du poste',
  employees_invite_phone_label: 'Téléphone',
  employees_invite_type_label: 'Type de compte',
  employees_invite_type_employee: 'Employé',
  employees_invite_type_admin: 'Administrateur',
  employees_invite_type_shipping_agent: 'Agent de livraison',
  roles_select_placeholder: 'Sélectionner un rôle',
  employees_invite_submit: 'Envoyer l’invitation',
  employees_invite_sending: 'Envoi…',
  employees_invite_success: 'E-mail d’invitation envoyé à l’employé.',
  employees_invite_error: 'Impossible d’envoyer l’invitation.',
  employees_table_title: 'Membres de l’équipe',
  employees_table_loading: 'Chargement des employés…',
  employees_table_empty:
    'Aucun employé pour le moment. Envoyez une invitation pour commencer.',
  employees_table_col_name: 'Nom',
  employees_table_col_email: 'E-mail',
  employees_table_col_role: 'Rôle',
  employees_table_col_status: 'Statut',
  employees_blocked_intrusion: 'Bloqué (intrusion, libre-service)',
  employees_table_col_roles: 'Rôles',
  employees_table_status_active: 'ACTIF',
  employees_action_enable: 'Activer',
  employees_action_disable: 'Désactiver',
  employees_status_error: 'Impossible de mettre à jour le statut de l’employé.',
  employees_roles_manage: 'Gérer les rôles',
  employees_roles_modal_title: 'Attribuer des rôles',
  employees_roles_load_error: 'Impossible de charger les rôles.',
  employees_roles_save_error: 'Impossible de mettre à jour les rôles.',

  roles_title: 'Rôles et permissions',
  roles_subtitle: 'Créez des rôles et attribuez des permissions fines pour chaque fonctionnalité.',
  roles_list_title: 'Rôles',
  roles_new: 'Nouveau rôle',
  roles_field_name: 'Nom du rôle',
  roles_name_placeholder: 'ex. COMPTABLE',
  roles_field_description: 'Description',
  roles_description_placeholder: 'Description courte',
  roles_create: 'Créer le rôle',
  roles_manage: 'Gérer',
  roles_badge_system: 'Système',
  roles_col_name: 'Nom',
  roles_col_description: 'Description',
  roles_col_permissions: 'Permissions',
  roles_col_users: 'Utilisateurs',
  roles_empty: 'Aucun rôle pour le moment.',
  roles_load_error: 'Impossible de charger les rôles.',
  roles_create_error: 'Impossible de créer le rôle.',
  roles_manage_title: 'Gérer le rôle',
  roles_group_help: 'Sélectionnez ce que ce rôle peut faire dans cette section.',
  roles_group_select_all: 'Tout sélectionner',
  roles_group_clear: 'Effacer',
  roles_group_all: 'Tout',
  roles_group_some: 'Partiel',
  roles_group_none: 'Aucun',
  roles_perm_catalog_error: 'Impossible de charger le catalogue des permissions.',
  roles_perm_load_error: 'Impossible de charger les permissions du rôle.',
  roles_perm_save_error: 'Impossible d’enregistrer les permissions.',
  roles_perm_save_success: 'Permissions enregistrées.',

  customers_title: 'Clients',
  customers_subtitle:
    'Filtrez l’annuaire, triez par dépenses ou volume de commandes, puis ouvrez un client pour le profil complet et les commandes.',
  customers_loading: 'Chargement des clients…',
  customers_empty: 'Aucun client ne correspond à vos filtres.',
  customers_error: 'Impossible de charger les clients.',
  customers_table_col_name: 'Nom',
  customers_table_col_email: 'E-mail',
  customers_table_col_phone: 'Téléphone',
  customers_table_col_status: 'Statut',
  customers_filter_section: 'Filtres',
  customers_filter_show: 'Afficher les filtres',
  customers_filter_hide: 'Masquer les filtres',
  customers_filter_collapsed_hint:
    'Filtres masqués pour un tableau plus lisible. Les critères actifs restent appliqués.',
  customers_filter_section_hint:
    'Le pays et la ville proposent des valeurs issues des profils clients. Choisissez d’abord le pays pour limiter les villes.',
  customers_suggest_loading: 'Chargement des suggestions…',
  customers_suggest_error:
    'Impossible de charger les suggestions. Vérifiez la connexion ou réessayez.',
  customers_suggest_no_countries: 'Aucun pays enregistré sur les profils clients.',
  customers_suggest_no_cities: 'Aucune ville enregistrée sur les profils clients.',
  customers_suggest_no_match: 'Aucune valeur correspondante dans vos données clients.',
  customers_filter_search: 'Recherche (nom, e-mail, téléphone)',
  customers_filter_search_ph: 'Saisir pour filtrer…',
  customers_filter_phone: 'Téléphone',
  customers_filter_phone_ph: 'Chiffres ou préfixe +',
  customers_filter_country: 'Pays',
  customers_filter_country_ph: 'ex. France',
  customers_filter_city: 'Ville',
  customers_filter_city_ph: 'ex. Paris',
  customers_filter_registered_from: 'Inscrit depuis',
  customers_filter_registered_to: 'Inscrit jusqu’au',
  customers_filter_apply: 'Appliquer les filtres',
  customers_filter_reset: 'Réinitialiser',
  customers_sort_label: 'Trier par',
  customers_sort_created_desc: 'Inscription la plus récente',
  customers_sort_created_asc: 'Inscription la plus ancienne',
  customers_sort_spend_desc: 'Dépense totale la plus élevée (USD)',
  customers_sort_spend_asc: 'Dépense totale la plus faible (USD)',
  customers_sort_orders_desc: 'Plus de commandes',
  customers_sort_orders_asc: 'Moins de commandes',
  customers_col_orders: 'Commandes',
  customers_col_spend: 'Dépense (USD)',
  customers_col_city: 'Ville',
  customers_col_country: 'Pays',
  customers_col_drive_time: 'Temps de trajet',
  customers_col_actions: 'Actions',
  customers_open_detail: 'Voir',
  customer_archives_title: 'Comptes supprimés — archives',
  customer_archives_subtitle:
    'Instantanés immuables lorsque des clients ont supprimé leur compte. Les commandes restent (sans lien client) ; ouvrez une archive pour le JSON et les liens vers les commandes.',
  customer_archives_search_label: 'Recherche',
  customer_archives_search_ph: 'E-mail normalisé ou ancien id utilisateur',
  customer_archives_search_submit: 'Rechercher',
  customer_archives_empty: 'Aucune archive de suppression pour le moment.',
  customer_archives_error: 'Impossible de charger les archives.',
  customer_archives_col_deleted: 'Supprimé le',
  customer_archives_col_name: 'Nom (instantané)',
  customer_archives_col_email: 'E-mail (normalisé)',
  customer_archives_col_former_id: 'Ancien id utilisateur',
  customer_archives_col_orders: 'Commandes (instantané)',
  customer_archives_col_actions: 'Actions',
  customer_archives_open: 'Ouvrir',
  customer_archives_page_range: '{{from}}–{{to}} sur {{total}}',
  customer_archive_detail_back: 'Liste des archives',
  customer_archive_detail_title: 'Archive de suppression',
  customer_archive_detail_subtitle:
    'Instantané conformité au moment de la suppression. Commandes « live » si vous avez ORDER:READ.',
  customer_archive_detail_summary: 'Résumé',
  customer_archive_detail_trigger: 'Déclencheur',
  customer_archive_detail_orders_live: 'Commandes (live)',
  customer_archive_detail_order_id: 'Id commande',
  customer_archive_detail_batch: 'Lot de livraison',
  customer_archive_detail_open_order: 'Ouvrir dans commandes',
  customer_archive_detail_snapshot_json: 'Instantané complet (JSON)',
  customer_archive_detail_snapshot_hint:
    'Profil, ids de commande, parrainage, enquête de sortie, prévisualisations.',
  customer_archive_detail_not_found: 'Archive introuvable.',
  customer_archive_detail_error: 'Impossible de charger l’archive.',
  customers_total_count: '{{count}} clients',
  customers_page_range: '{{from}}–{{to}} sur {{total}}',
  customers_page_of: 'Page {{page}} / {{pages}}',
  customers_page_prev: 'Précédent',
  customers_page_next: 'Suivant',
  customers_rows_per_page: 'Lignes par page',
  customers_page_showing: 'Page {{page}} / {{pages}}',
  customers_detail_back: 'Retour aux clients',
  customers_detail_loading: 'Chargement du client…',
  customers_detail_error: 'Impossible de charger le client.',
  customers_detail_not_found: 'Client introuvable.',
  customers_detail_total_spend: 'Dépense totale',
  customers_detail_orders: 'commandes',
  customers_detail_profile: 'Profil',
  customers_detail_id: 'ID client',
  customers_detail_address: 'Adresse',
  customers_detail_lat_lng: 'Lat / Long',
  customers_detail_drive_time: 'Temps de trajet (magasin → adresse)',
  customers_detail_drive_status: 'Statut d’itinéraire',
  customers_detail_created: 'Créé le',
  customers_detail_last_login: 'Dernière connexion',
  customers_detail_preferences: 'Préférences',
  customers_detail_order_summary: 'Résumé des commandes',
  customers_detail_last_order: 'Dernière commande',
  customers_detail_status_counts: 'Nombre par statut',
  customers_detail_orders_section: 'Commandes',
  customers_detail_no_orders: 'Aucune commande pour ce client.',
  sidebar_account_deletion_retention: 'Rétention à la suppression de compte',
  customers_detail_account_lifecycle: 'Suppression de compte et rétention',
  customers_detail_account_lifecycle_hint:
    'Conservation de l’e-mail, archives de suppression (dont enquête) et événements récents du flux de suppression pour ce compte.',
  customers_detail_retained_email_title: 'E-mail conservé',
  customers_detail_delete_count: 'Suppressions antérieures (cet e-mail)',
  customers_detail_first_seen: 'Première conservation',
  customers_detail_last_deleted: 'Dernière suppression le',
  customers_detail_archives: 'Archives de suppression',
  customers_detail_archive_deleted_at: 'Supprimé le',
  customers_detail_exit_survey: 'Enquête de départ',
  customers_detail_exit_reasons: 'Raisons sélectionnées',
  customers_detail_exit_comment: 'Commentaire',
  customers_detail_recent_attempts: 'Tentatives récentes de suppression',
  customers_detail_attempt_kind: 'Type',
  customers_detail_attempt_at: 'Quand',
  account_deletion_retention_title: 'Suppression de compte et rétention',
  account_deletion_retention_blurb:
    'Configurez l’offre de fidélisation lors d’une suppression de compte, les limites anti-abus et les options d’enquête lorsque le plafond d’offres est atteint.',
  account_deletion_retention_load_error:
    'Impossible de charger les paramètres de rétention à la suppression.',
  account_deletion_retention_saved: 'Paramètres de rétention enregistrés.',
  account_deletion_retention_save_error: 'Impossible d’enregistrer les paramètres.',
  account_deletion_retention_enabled: 'Activer le flux de rétention',
  account_deletion_retention_window_days: 'Fenêtre glissante (jours)',
  account_deletion_retention_window_days_hint:
    'Les aperçus dans cette fenêtre comptent pour la limite d’offres.',
  account_deletion_retention_max_offers: 'Offres de rétention max. par fenêtre',
  account_deletion_retention_max_offers_hint:
    'Après autant d’aperçus dans la fenêtre, l’offre est masquée et l’enquête est obligatoire.',
  account_deletion_retention_offer_title: 'Titre de l’offre',
  account_deletion_retention_offer_body: 'Texte de l’offre',
  account_deletion_retention_promo_code: 'Code promo optionnel',
  account_deletion_retention_promo_hint:
    'Affiché au client ; doit exister dans Promotions pour une application automatique.',
  account_deletion_retention_exit_reasons: 'Raisons de l’enquête de départ',
  account_deletion_retention_add_reason: 'Ajouter une raison',
  account_deletion_retention_exit_reasons_hint:
    'Lorsque le plafond est dépassé, le client doit choisir avant de supprimer.',
  account_deletion_retention_label: 'Libellé',
  account_deletion_retention_discount_percent: 'Remise unique de fidélisation (% du sous-total)',
  account_deletion_retention_discount_percent_hint:
    'Appliquée une fois sur la prochaine commande après acceptation de l’offre (enregistrée sur la commande pour la finance).',
  account_deletion_retention_email_cooldown_days: 'Délai par e-mail avant nouvelle offre (jours)',
  account_deletion_retention_email_cooldown_days_hint:
    'Après acceptation de l’offre ou utilisation de la remise unique, l’offre de rétention est bloquée pour cette durée pour cet e-mail (même après suppression et réinscription). 0 pour désactiver.',
  orders_discount_retention: 'Rétention compte (offre de maintien)',
  customers_detail_col_id: 'ID',
  customers_detail_col_date: 'Date',
  customers_detail_col_total: 'Total',
  customers_detail_col_city: 'Ville',
  customers_detail_items_count: '{{count}} articles',
  // Catalogue / produits
  products_title: 'Produits & catalogue',
  products_subtitle:
    'Gérez les produits, les prix et les images utilisés dans votre boutique.',
  products_search_placeholder: 'Rechercher par nom ou SKU',
  products_search_button: 'Rechercher',
  products_search_clear: 'Effacer',
  products_add_button: 'Ajouter un produit',
  products_hide_form: 'Masquer le formulaire',
  products_name_label: 'Nom',
  products_description_label: 'Description',
  products_image_label: "URL de l'image",
  products_unit_label: 'Unité de base',
  products_unit_lb: 'Livre (lb)',
  products_unit_kg: 'Kilogramme (kg)',
  products_price_label: 'Prix par unité',
  products_delivery_fee_label: 'Frais de livraison fixes (optionnel)',
  products_saving: 'Enregistrement…',
  products_update_button: 'Mettre à jour le produit',
  products_create_button: 'Créer le produit',
  products_table_title: 'Catalogue produits',
  products_loading: 'Chargement des produits…',
  products_empty:
    'Aucun produit pour le moment. Créez votre premier produit ci‑dessus.',
  products_table_col_name: 'Nom',
  products_table_col_sku: 'SKU',
  products_table_col_category: 'Catégorie',
  products_table_col_price: 'Prix / unité',
  products_table_col_sale_price: 'Prix promo',
  products_table_col_stock: 'Stock (lb)',
  products_prev_page: 'Précédent',
  products_next_page: 'Suivant',
  products_action_edit: 'Modifier',
  // Inventaire & achats
  inventory_title: 'Inventaire & contrôle du stock',
  inventory_subtitle:
    'Suivez les lots de stock, les dates de péremption et l’historique des achats avec recherche et filtres rapides.',
  inventory_tab_lots: 'Lots de stock',
  inventory_tab_purchases: "Historique d'achat",
  inventory_search_button: 'Rechercher',
  inventory_lots_search: 'Rechercher par nom de produit',
  inventory_lots_loading: 'Chargement des lots de stock…',
  inventory_lots_empty: 'Aucun lot de stock trouvé.',
  inventory_lots_col_product: 'Produit',
  inventory_lots_col_batch: 'Lot',
  inventory_lots_col_purchased: 'Acheté (lb)',
  inventory_lots_col_remaining: 'Restant (lb)',
  inventory_lots_col_expiry: 'Date de péremption',
  inventory_prev_page: 'Précédent',
  inventory_next_page: 'Suivant',
  inventory_purchases_search: 'Rechercher par fournisseur ou référence',
  inventory_purchases_from: 'Du',
  inventory_purchases_to: 'Au',
  inventory_purchases_loading: 'Chargement des achats…',
  inventory_purchases_empty:
    "Aucun achat trouvé pour les filtres sélectionnés.",
  inventory_purchases_col_date: 'Date',
  inventory_purchases_col_supplier: 'Fournisseur',
  inventory_purchases_col_ref: 'Référence',
  inventory_purchases_col_items: 'Articles',
  inventory_purchases_col_total: 'Total',

  // Budget
  budget_title: 'Budget',
  budget_subtitle: 'Définissez les périodes budgétaires. Achats, pertes et autres dépenses sont déduits automatiquement.',
  budget_periods: 'Périodes budgétaires',
  budget_new: 'Nouvelle période',
  budget_name: 'Nom de la période',
  budget_initial: 'Montant initial',
  budget_create: 'Créer',
  budget_loading: 'Chargement…',
  budget_empty: 'Aucune période budgétaire pour l’instant.',
  budget_overbudget: 'Dépassement',
  budget_hide_detail: 'Masquer le détail',
  budget_view_detail: 'Voir le détail',
  budget_activate: 'Activer',
  budget_close: 'Clôturer',
  budget_balance: 'Solde',
  budget_adjustment: 'Ajustement (+/-)',
  budget_description: 'Description',
  budget_add_adjustment: 'Ajouter un ajustement',
  budget_expense_amount: 'Montant de la dépense',
  budget_expense_desc: 'ex. Serveurs, publicité',
  budget_add_expense: 'Ajouter une dépense',
  budget_type: 'Type',
  budget_amount: 'Montant',
  budget_date: 'Date',
  budget_entry_type_initial: 'Initial',
  budget_entry_type_adjustment: 'Ajustement',
  budget_entry_type_purchase: 'Achat',
  budget_entry_type_loss: 'Perte',
  budget_entry_type_expense_other: 'Autre dépense',

  // Losses
  losses_title: 'Enregistrer les pertes',
  losses_subtitle: 'Enregistrez les pertes de produits (péremption, casse, perte). Déduit du stock et du budget actif.',
  losses_history: 'Historique des pertes',
  losses_record: 'Enregistrer une perte',
  losses_product: 'Produit',
  losses_search_product: 'Rechercher un produit',
  losses_lot: 'Lot (optionnel)',
  losses_quantity: 'Quantité (lb)',
  losses_reason: 'Motif',
  losses_notes: 'Notes',
  losses_submit: 'Enregistrer la perte',
  losses_col_date: 'Date',
  losses_col_product: 'Produit',
  losses_col_lot: 'Lot',
  losses_col_qty: 'Qté (lb)',
  losses_col_value: 'Valeur',
  losses_col_reason: 'Motif',
  losses_col_notes: 'Notes',
  losses_empty: 'Aucune perte enregistrée.',
  losses_total_value: 'Valeur totale des pertes',
  losses_filtered: 'filtré',
  losses_filter_by_reason: 'Filtrer par motif',
  losses_all_reasons: 'Tous les motifs',
  losses_from_date: 'Date de début',
  losses_to_date: 'Date de fin',
  losses_clear_filters: 'Effacer les filtres',
  loss_reason_expired: 'Péremption',
  loss_reason_damaged: 'Casse',
  loss_reason_lost: 'Perdu',
  loss_reason_theft: 'Vol',
  loss_reason_other: 'Autre',

  sidebar_payments: 'Paiements',
  sidebar_promotions: 'Promotions',
  sidebar_referrals: 'Parrainage',
  referrals_stat_pending: 'En attente',
  referrals_stat_qualified: 'Qualifiés',
  referrals_stat_rejected: 'Rejetés',
  referrals_stat_codes: 'Codes émis',
  referrals_stat_signup_sessions: 'Sessions inscription',
  referrals_stat_checkout_queue: 'File paiement',
  referrals_deactivated_wind_down:
    'Programme désactivé pour les nouveaux liens et inscriptions sans session enregistrée. En cours : {{pending}} parrainage(s) en attente, {{intents}} session(s) d’inscription (48 h), {{checkout}} commande(s) non payée(s) avec remise bienvenue parrainage.',
  referrals_wind_down_explainer:
    'Les nouveaux liens publics sont désactivés. Les clients ayant déjà ouvert l’inscription avec un parrainage (session 48 h) peuvent terminer. Les filleuls avec une première commande en attente conservent la remise jusqu’au paiement ou à l’annulation.',
  payments_title: 'Paiements',
  payments_subtitle:
    'Paiements carte Stripe : client, commande, montant, statut et métadonnées sûres (marque, 4 derniers). Aucun numéro complet n’est stocké.',
  payments_load_error: 'Impossible de charger les paiements.',
  payments_filter_search: 'Recherche',
  payments_filter_search_ph: 'Commande, intent, e-mail, last4…',
  payments_filter_status: 'Statut Stripe',
  payments_filter_from: 'Du',
  payments_filter_to: 'Au',
  payments_apply: 'Appliquer',
  payments_col_date: 'Date',
  payments_col_customer: 'Client',
  payments_customer_deleted_badge: 'Compte supprimé',
  payments_customer_deleted_hint:
    'L’historique de paiement est conservé. Le profil client a été retiré à la suppression ; l’e-mail peut provenir du reçu Stripe ou de l’instantané de commande.',
  payments_col_order: 'Commande',
  payments_col_order_id: 'ID commande',
  payments_col_payment_id: 'ID paiement',
  payments_expand_order_id: 'ID commande',
  payments_expand_payment_id: 'ID paiement',
  payments_col_amount: 'Montant',
  payments_col_amount_tooltip:
    'Montant de ce paiement converti en USD (base back-office). Pour les précommandes, voir Commande (USD) : total, acompte et solde restant.',
  payments_col_order_balance: 'Commande (USD)',
  payments_order_total_short: 'Total',
  payments_order_deposit_short: 'Acompte',
  payments_order_remaining_short: 'Reste',
  payments_col_status: 'Statut',
  payments_col_card: 'Carte',
  payments_col_type: 'Type',
  payments_empty: 'Aucun paiement trouvé.',
  payments_view: 'Détails',
  payments_pci_note:
    'Les données sensibles sont tokenisées par Stripe. Cet écran n’affiche que des champs sûrs renvoyés après paiement.',
  payments_detail_title: 'Enregistrement de paiement',
  payments_detail_error: 'Impossible de charger le détail du paiement.',

  sidebar_group_security: 'Sécurité',
  sidebar_activities: 'Journal d’activité',
  activities_title: 'Journal d’activité',
  activities_subtitle:
    'Piste d’audit pour connexions, événements de sécurité et actions internes. Filtrez par période, IP, identifiants utilisateur, gravité et texte libre.',
  activities_load_error: 'Impossible de charger le journal d’activité.',
  activities_apply: 'Appliquer les filtres',
  activities_clear: 'Effacer les filtres',
  activities_filter_q: 'Recherche message / catégorie / action',
  activities_filter_q_ph: 'ex. login, brute',
  activities_filter_category: 'Catégorie (exacte)',
  activities_filter_action: 'Action (contient)',
  activities_filter_action_ph: 'ex. login.success',
  activities_filter_severity: 'Gravité',
  activities_filter_from: 'Date début',
  activities_filter_to: 'Date fin',
  activities_filter_actor: 'ID utilisateur acteur',
  activities_filter_target: 'ID utilisateur cible',
  activities_filter_ip: 'IP (exacte)',
  activities_filter_ip_contains: 'IP (contient)',
  activities_filter_subject_type: 'Type de sujet',
  activities_filter_subject_id: 'ID sujet',
  activities_page_size: 'Lignes par page',
  activities_col_time: 'Heure',
  activities_col_severity: 'Gravité',
  activities_col_category: 'Catégorie',
  activities_col_action: 'Action',
  activities_col_actor: 'Acteur',
  activities_col_ip: 'IP',
  activities_col_message: 'Message',
  activities_empty: 'Aucune activité ne correspond aux filtres.',
  activities_pagination_info: 'Page {{page}} sur {{totalPages}} · {{total}} événements',
  activities_detail_ids: 'Identifiants',
  activities_detail_request: 'Requête',
  activities_detail_metadata: 'Métadonnées (JSON)',

  promotions_title: 'Promotions',
  promotions_subtitle:
    'Créez des codes de réduction pour la caisse. Limitez-les à un client, à un montant cumulé ou à un sous-total minimum.',
  promotions_load_error: 'Impossible de charger les promotions.',
  promotions_empty: 'Aucune promotion pour l’instant.',
  promotions_col_code: 'Code',
  promotions_col_type: 'Type',
  promotions_col_value: 'Valeur',
  promotions_col_restricted: 'Compte uniquement',
  promotions_col_expires: 'Expire',
  promotions_col_active: 'Actif',
  promotions_col_actions: 'Actions',
  promotions_type_percent: 'Pourcent',
  promotions_type_fixed: 'Montant fixe USD',
  promotions_unlimited: '—',
  promotions_deactivate: 'Désactiver',
  promotions_create_open: 'Nouvelle promotion',
  promotions_form_code: 'Code',
  promotions_form_description: 'Description (interne)',
  promotions_form_discount_type: 'Type de remise',
  promotions_form_percent: 'Pourcentage (0–100)',
  promotions_form_fixed: 'Remise fixe (USD)',
  promotions_form_restricted_customer: "Limiter à l'e-mail client (optionnel)",
  promotions_form_restricted_ph: 'client@exemple.com',
  promotions_form_restricted_hint:
    "Si renseigné, seul le compte avec cet e-mail peut utiliser le code.",
  promo_seg_collapsed_sub:
    'Développez pour régler les filtres et lancer une recherche. Vous pouvez aussi restreindre un code par e-mail sans rechercher.',
  promo_seg_table_idle: 'Développez les filtres ci-dessus et cliquez sur Lancer la recherche pour charger les clients.',
  promotions_form_min_lifetime: 'Dépenses cumulées min. (USD, optionnel)',
  promotions_form_min_subtotal: 'Sous-total minimum (USD, optionnel)',
  promotions_form_max_total: 'Utilisations max. totales (optionnel)',
  promotions_form_max_per_customer: 'Max. par client (optionnel)',
  promotions_form_expires: 'Expire le (optionnel, local)',
  promotions_form_active: 'Actif',
  promotions_save: 'Créer la promotion',
  promotions_save_error: 'Impossible d’enregistrer.',
  promotions_deactivate_error: 'Impossible de désactiver.',

  delivery_batches_title: 'Lots de livraison',
  delivery_batches_subtitle:
    'Regrouper les commandes payées par zone et fenêtre pour les tournées. Déplacer les commandes entre lots avant expédition.',
  delivery_batches_load_error: 'Impossible de charger les lots.',
  delivery_batches_save_error: 'Enregistrement du lot impossible.',
  delivery_batches_create: 'Nouveau lot',
  delivery_batches_area_label: 'Zone',
  delivery_batches_area_ph: 'ex. Lot New York',
  delivery_batches_name_optional: 'Nom interne (optionnel)',
  delivery_batches_country_optional: 'Pays (optionnel)',
  delivery_batches_city_optional: 'Ville (optionnel)',
  delivery_batches_window_start: 'Début de fenêtre',
  delivery_batches_window_end: 'Fin de fenêtre',
  delivery_batches_estimated_window: 'Fenêtre de livraison estimée',
  delivery_batches_notes_optional: 'Notes (optionnel)',
  delivery_batches_save: 'Créer le lot',
  delivery_batches_list: 'Lots',
  delivery_batches_empty: 'Aucun lot pour l’instant.',
  delivery_batches_select: 'Sélectionnez un lot pour voir les commandes.',
  delivery_batches_detail_error: 'Impossible de charger ce lot.',
  delivery_batches_close: 'Marquer fermé',
  delivery_batches_close_dispatch: 'Fermer le lot et expédier les commandes',
  delivery_batches_close_confirm:
    'Fermer ce lot ? Toutes les commandes payées seront expédiées en tâche de fond (pas dans cette requête). Vous pouvez quitter et revenir plus tard pour voir l’avancement.',
  delivery_batches_dispatching:
    'Tâche de fond en cours… les commandes passent en EXPÉDIÉ. Le lot se fermera automatiquement.',
  delivery_batches_dispatch_progress: '{{processed}} / {{total}} commandes traitées',
  delivery_batches_dispatch_background:
    'Vous pouvez quitter cette page — le progrès est enregistré. Rouvrez ce lot pour voir l’état en direct.',
  delivery_batches_dispatch_failed: 'Échec de l’expédition. Voir les détails ci-dessous.',
  delivery_batches_dispatch_partial_title: 'Certaines commandes n’ont pas pu être expédiées :',
  delivery_batches_dispatch_notice:
    'Fermeture mise en file. Les commandes payées seront marquées EXPÉDIÉES en arrière-plan.',
  delivery_batches_delete: 'Supprimer un lot vide',
  delivery_batches_delete_confirm: 'Supprimer ce lot ? Uniquement s’il n’a pas de commandes.',
  delivery_batches_orders_count: '{{count}} commandes',
  delivery_batches_add_order: 'Assigner une commande payée',
  delivery_batches_pick_order: 'Choisir une commande…',
  delivery_batches_assign: 'Assigner',
  delivery_batches_in_batch: 'Commandes dans ce lot',
  delivery_batches_no_orders: 'Aucune commande dans ce lot.',
  delivery_batches_speed: 'Type de livraison',
  delivery_batches_remove: 'Retirer du lot',
  delivery_batches_create_expand: 'Afficher le formulaire',
  delivery_batches_create_collapse: 'Masquer le formulaire',
  delivery_batches_search_hint:
    'Saisissez pays et/ou ville (suggestions des commandes payées) ou mots-clés — résultats en direct.',
  delivery_batches_searching: 'Recherche…',
  delivery_batches_assign_country: 'Pays',
  delivery_batches_assign_country_ph: 'ex. France',
  delivery_batches_assign_town: 'Ville / commune',
  delivery_batches_assign_town_ph: 'ex. Paris',
  delivery_batches_order_search: 'Mots-clés (optionnel)',
  delivery_batches_order_search_ph: 'Id commande, nom client, e-mail…',
  delivery_batches_search_required: 'Indiquez au moins un pays, une ville ou un mot-clé, puis Rechercher.',
  delivery_batches_search_button: 'Rechercher',
  delivery_batches_search_empty_prompt:
    'Commencez à saisir un pays, une ville ou un mot-clé — recherche en direct des commandes payées.',
  delivery_batches_select_all_results: 'Tout sélectionner dans les résultats',
  delivery_batches_select_all_area: 'Tout sélectionner dans cette zone',
  delivery_batches_clear_selection: 'Effacer la sélection',
  delivery_batches_area_unknown: 'Adresse incomplète',
  delivery_batches_suggest_hint:
    'Cliquez sur les lignes pour sélectionner. Les commandes déjà dans ce lot sont masquées.',
  delivery_batches_selected_n: '{{count}} sélectionné(s)',
  delivery_batches_assign_selected: 'Assigner la sélection',
  delivery_batches_other_batch: 'Dans : {{batch}}',
  delivery_batches_no_search_matches: 'Aucune commande ne correspond.',
  sidebar_delivery_batches: 'Lots de livraison',
  orders_delivery_speed: 'Livraison',
  orders_batch_label: 'Lot',
  orders_no_batch: 'Pas encore assignée à un lot',
  orders_receipt_download: 'Reçu (PDF)',
  orders_receipt_error: 'Impossible de télécharger le reçu.',
  orders_progress_title: 'Progression de la commande',
  orders_progress_simple_subtitle: 'Préparation standard',
  orders_progress_incident_badge: 'Parcours incident & remboursement',
  orders_progress_main: 'Préparation & livraison',
  orders_progress_refund_step: 'Remboursement',
  orders_progress_branch: 'Incident & renvoi',
  orders_progress_issue: 'Incident',
  orders_progress_investigating: 'Enquête',
  orders_progress_resolution: 'Responsabilité',
  orders_progress_reship_prep: 'File renvoi',
  orders_progress_out_again: 'Réexpédiée',
  orders_progress_merge_delivered: 'Puis livraison finale',
  orders_progress_unreachable_short: 'Injoignable',
  orders_progress_damaged_short: 'Endommagé',
  orders_progress_fault_employee: 'Faute équipe',
  orders_progress_fault_customer: 'Faute client',
  orders_progress_refund_sidebar:
    'Remboursement ou retour en cours — le parcours peut différer du fil standard.',
  orders_progress_delivered_skipped: 'n/a',
  incident_open_unreachable_confirm_title: 'Confirmer incident injoignable',
  incident_open_unreachable_confirm_message:
    'Marquer cette commande comme injoignable ?',
  incident_open_unreachable_confirm_message_batched:
    'Cette commande est dans le lot « {{batch}} ». Elle sera retirée du lot pour traiter cette livraison injoignable hors tournée du lot. Continuer ?',
  incident_open_damaged_confirm_title: 'Confirmer incident endommagé',
  incident_open_damaged_confirm_message: 'Marquer cette commande comme endommagée ?',
  incident_open_damaged_confirm_message_batched:
    'Cette commande est dans le lot « {{batch}} ». Elle sera retirée du lot pour traiter cet envoi endommagé hors tournée du lot. Continuer ?',

  sidebar_delivery_pricing: 'Tarifs de livraison',
  delivery_pricing_title: 'Tarifs de livraison',
  delivery_pricing_subtitle:
    'Choisissez le mode (poids ou temps de trajet) et les paliers standard/express. L’origine pour le temps de route reprend les coordonnées du contact public (enregistrées lors du choix d’adresse). Calcul en arrière-plan.',
  delivery_pricing_load_error: 'Impossible de charger les paramètres.',
  delivery_pricing_save_error: 'Enregistrement impossible.',
  delivery_pricing_saved: 'Paramètres enregistrés.',
  delivery_pricing_store_section: 'Origine (temps de trajet)',
  delivery_pricing_store_public_contact_info:
    'Mêmes coordonnées que le contact public. Choisissez une adresse suggérée pour enregistrer lat/long — pas besoin de les saisir ici.',
  delivery_pricing_store_edit_public_contact: 'Modifier le contact public',
  delivery_pricing_store_resolved: 'Origine utilisée',
  delivery_pricing_store_source_public: 'Contact public',
  delivery_pricing_store_source_override: 'Surcharge manuelle',
  delivery_pricing_store_source_none: 'Pas encore de coordonnées',
  delivery_pricing_store_no_coords_hint:
    'Ouvrez Contact public, pays et ville, puis une adresse parmi les suggestions.',
  delivery_pricing_store_override_section: 'Optionnel : coordonnées manuelles',
  delivery_pricing_store_override_hint: 'Si l’origine doit différer du contact public.',
  delivery_pricing_store_clear_override: 'Utiliser le contact public',
  delivery_pricing_clear_override_confirm:
    'Supprimer la surcharge et utiliser les coordonnées du contact public ?',
  delivery_pricing_store_set_override: 'Enregistrer la surcharge',
  delivery_pricing_latitude: 'Latitude',
  delivery_pricing_longitude: 'Longitude',
  delivery_pricing_label: 'Libellé (optionnel)',
  delivery_pricing_mode_label: 'Mode de tarification',
  delivery_pricing_mode_weight: 'Par poids (hérité)',
  delivery_pricing_mode_driving: 'Temps de conduite (magasin → client)',
  delivery_pricing_weight_section: 'Frais au poids (secours)',
  delivery_pricing_weight_base: 'Frais de base (USD)',
  delivery_pricing_weight_per_lb: 'Par lb (USD)',
  delivery_pricing_express_surcharge: 'Surtaxe express (USD)',
  delivery_pricing_weight_days_standard: 'Jours standard (mode poids)',
  delivery_pricing_weight_days_express: 'Jours express (mode poids)',
  delivery_pricing_driving_section: 'Paliers temps de trajet',
  delivery_pricing_standard_days: 'Délai standard (jours)',
  delivery_pricing_express_days: 'Délai express (jours)',
  delivery_pricing_tiers_hint:
    'Chaque ligne : minutes max (incluses) et montant USD. Trier par minutes croissantes ; une grande valeur pour la dernière ligne.',
  delivery_pricing_standard_tiers: 'Paliers standard (JSON)',
  delivery_pricing_express_tiers: 'Paliers express (JSON)',
  delivery_pricing_recompute_all: 'Recalcul pour tous les clients',
  delivery_pricing_recompute_all_confirm: 'Mettre en file tous les clients ? Peut prendre du temps.',
  delivery_pricing_recompute_all_done: '{{count}} tâches mises en file.',
  delivery_pricing_redis_hint:
    'Nécessite Redis (BullMQ) et GOOGLE_MAPS_API_KEY avec Routes API activée (pas l’ancienne Distance Matrix).',
  delivery_pricing_readonly:
    'Lecture seule. DELIVERY_PRICING:UPDATE (ou admin) requis pour modifier.',

  delivery_pricing_rules_section: 'Règles de prix (sous-total + poids + distance + pays)',
  delivery_pricing_express_enabled: 'Activer la livraison express',
  delivery_pricing_store_country: 'Pays du magasin (code ISO)',
  delivery_pricing_days_standard: 'Délai standard (jours)',
  delivery_pricing_days_express: 'Délai express (jours)',
  delivery_pricing_countries_section: 'Pays de destination',
  delivery_pricing_add_country: 'Ajouter un pays',
  delivery_pricing_country_code: 'Code pays',
  delivery_pricing_country_express_enabled: 'Express activé pour ce pays',
  delivery_pricing_border_fee: 'Frais frontière (USD)',
  delivery_pricing_base_fee: 'Frais de base (USD)',
  delivery_pricing_per_mile: 'Par mile (USD)',
  delivery_pricing_per_lb: 'Par lb (USD)',
  delivery_pricing_us_threshold_section: 'Seuil USA (gratuit / forfait)',
  delivery_pricing_free_min_subtotal: 'Sous-total min (USD)',
  delivery_pricing_free_max_weight: 'Poids max (lb)',
  delivery_pricing_free_fee: 'Frais si éligible (USD)',
  delivery_pricing_preview_title: 'Calculatrice (aperçu)',
  delivery_pricing_preview_hint: 'Testez des valeurs avant d’enregistrer.',
  delivery_pricing_preview_subtotal: 'Sous-total (USD)',
  delivery_pricing_preview_weight: 'Poids total (lb)',
  delivery_pricing_preview_miles: 'Distance (miles)',
  delivery_pricing_preview_country: 'Pays de destination',
  delivery_pricing_preview_standard_fee: 'Frais standard',
  delivery_pricing_preview_express_fee: 'Frais express',
  delivery_pricing_preview_express_unavailable: 'Express indisponible (désactivé globalement ou pour ce pays).',
  delivery_pricing_preview_threshold_applied: 'Seuil appliqué.',
  delivery_pricing_preview_invalid_country: 'Entrez un code pays (ex. US).',
  delivery_pricing_preview_country_missing: 'Aucune règle configurée pour {{country}}.',

  orders_col_order_id: 'ID commande',
  orders_col_total: 'Total',
  orders_preorder_card_payments_heading: 'Paiements par carte',
  orders_preorder_deposit_payment: 'Acompte (premier débit)',
  orders_preorder_balance_payment: 'Solde (après libération)',
  orders_preorder_balance_payments_heading: 'Débits de solde (après libération)',
  orders_preorder_balance_payment_index: 'Débit {{n}}',
  orders_preorder_balance_payment_pending:
    'Pas encore de débit du solde. Le client paie le reste après votre libération de la précommande.',
  orders_customer_account_deleted_banner:
    'Compte client supprimé — commande archivée côté opérations. Statut, lots, incidents et renvoi sont désactivés. La vérification Stripe ci-dessous reste possible pour marquer un paiement en attente.',
  orders_customer_account_deleted_badge: 'Compte supprimé',
  orders_workflow_frozen_short: 'Archivée (pas de workflow)',
  orders_view_scope: 'Vue commandes',
  orders_filters_label: 'Recherche et filtres',

  mail_routing_title: 'Expéditeurs e-mail',
  mail_routing_subtitle:
    'Choisir les adresses From et Reply-To par type d’e-mail. Utilisez des identités vérifiées dans Amazon SES. La première adresse From est utilisée pour chaque usage ; ajoutez un Reply-To no-reply si besoin.',
  mail_routing_load_error: 'Impossible de charger les paramètres.',
  mail_routing_save_error: 'Impossible d’enregistrer.',
  mail_routing_saved: 'Expéditeurs enregistrés.',
  mail_routing_hint:
    'Laissez une section vide pour utiliser SES_SOURCE_EMAIL et MAIL_DEFAULT_REPLY_TO du serveur. Vous pouvez lister plusieurs From ; seule la première est utilisée comme expéditeur.',
  mail_routing_readonly:
    'Consultation seule : seuls les comptes avec « Configurer les expéditeurs e-mail » (MAIL_ROUTING:UPDATE) peuvent modifier.',
  mail_routing_from: 'Adresses From (une par ligne)',
  mail_routing_from_help:
    'Doivent être vérifiées dans AWS SES. La première adresse est utilisée comme expéditeur.',
  mail_routing_reply_to: 'Reply-To (no-reply recommandé)',
  mail_routing_bcc: 'BCC (optionnel, copies internes)',
  mail_routing_bcc_help:
    'Destinataires en copie invisible du même message (alertes internes, etc.).',
  mail_routing_save: 'Enregistrer les expéditeurs',
  mail_routing_saving: 'Enregistrement…',

  mail_routing_purpose_EMAIL_VERIFICATION: 'Vérification e-mail',
  mail_routing_purpose_PASSWORD_RESET: 'Réinitialisation du mot de passe',
  mail_routing_purpose_MFA_LOGIN_CODE: 'Code de connexion (MFA)',
  mail_routing_purpose_EMPLOYEE_INVITE: 'Invitation employé',
  mail_routing_purpose_WELCOME_CUSTOMER: 'Bienvenue (nouveau client)',
  mail_routing_purpose_ORDERS_CUSTOMER: 'Commandes (client)',
  mail_routing_purpose_ORDERS_STAFF: 'Commandes (équipe)',
  mail_routing_purpose_BUDGET_REPORT: 'Rapports budget',
  mail_routing_purpose_EXPIRY_ALERT: 'Alertes d’expiration',
  mail_routing_purpose_GENERAL: 'Autre / défaut',
  mail_routing_purpose_REFERRAL: 'Parrainage (client)',
} as const;

export const frRbac = {
  perm_group: {
    catalog: 'Catalogue',
    inventory: 'Stock',
    orders: 'Commandes',
    payments: 'Paiements (Stripe)',
    finance: 'Finance',
    settings: 'Paramètres',
    users: 'Utilisateurs',
    rbac: 'Contrôle d’accès',
    security: 'Sécurité & audit',
  },
  perm_desc: {
    payment: {
      read:
        'Accéder à l’espace Paiements : liste des encaissements carte, recherche et filtres, détail (intent Stripe, carte, commande liée).',
    },
  },
  perm: {
    product: {
      read: 'Lire les produits',
      create: 'Créer des produits',
      update: 'Mettre à jour des produits',
      delete: 'Supprimer des produits',
      upload: 'Téléverser des images produit',
    },
    category: {
      read: 'Lire les catégories',
      create: 'Créer des catégories',
      update: 'Mettre à jour des catégories',
      delete: 'Supprimer des catégories',
    },
    supplier: {
      read: 'Lire les fournisseurs',
      create: 'Créer des fournisseurs',
      update: 'Mettre à jour des fournisseurs',
      delete: 'Supprimer des fournisseurs',
    },
    order: {
      read: 'Lire les commandes',
      update: 'Mettre à jour les commandes',
    },
    order_detail: {
      read: 'View order details',
    },
    order_incident: {
      read: 'View order incidents',
      update: 'Manage order incidents',
    },
    order_resolution: {
      read: 'View incident resolutions',
      update: 'Resolve order incidents',
    },
    order_reship: {
      create: 'Reship orders after employee fault',
    },
    order_stats: {
      read: 'View order analytics',
    },
    promotion: {
      read: 'Voir les promotions',
      create: 'Créer des promotions',
      update: 'Modifier des promotions',
      delete: 'Désactiver des promotions',
    },
    referral: {
      read: 'Voir le programme de parrainage',
      update: 'Configurer le parrainage et les e-mails d’annonce',
    },
    payment: {
      read: 'Voir l’espace paiements Stripe',
    },
    mail_routing: {
      read: 'Voir les expéditeurs e-mail',
      update: 'Configurer les expéditeurs e-mail',
    },
    purchase: {
      read: 'Lire les achats',
      create: 'Créer des achats',
      update: 'Mettre à jour des achats',
      delete: 'Supprimer des achats',
    },
    purchase_order: {
      read: 'Lire les bons de commande',
      create: 'Créer des bons de commande',
      update: 'Mettre à jour des bons de commande',
      delete: 'Supprimer des bons de commande',
      complete: 'Clôturer des bons de commande',
      print: 'Imprimer des bons de commande',
    },
    stock_lot: {
      read: 'Lire les lots de stock',
      update: 'Mettre à jour les lots de stock',
    },
    loss: {
      read: 'Lire les pertes',
      create: 'Enregistrer des pertes',
    },
    budget_period: {
      read: 'Lire les périodes de budget',
      create: 'Créer des périodes de budget',
      update: 'Mettre à jour des périodes de budget',
      delete: 'Supprimer des périodes de budget',
    },
    budget_report: {
      create: 'Générer des rapports de budget',
    },
    currency: {
      read: 'Lire les devises',
      update: 'Gérer les devises',
    },
    ui_setting: {
      read: 'Voir les paramètres d’affichage',
      update: 'Modifier les paramètres d’affichage',
    },
    expiry_alert: {
      read: 'Lire les alertes d’expiration',
      update: 'Gérer les alertes d’expiration',
    },
    hero: {
      read: 'Lire les slides hero',
      create: 'Créer des slides hero',
      update: 'Mettre à jour des slides hero',
      delete: 'Supprimer des slides hero',
      upload: 'Téléverser des images hero',
    },
    employee: {
      read: 'Lire les employés',
      create: 'Créer des employés',
      update: 'Mettre à jour des employés',
    },
    customer: {
      read: 'Lire les clients',
    },
    delivery_pricing: {
      read: 'Voir les paramètres de livraison',
      update: 'Configurer les tarifs et le magasin',
    },
    role: {
      read: 'Lire les rôles',
      create: 'Créer des rôles',
      update: 'Mettre à jour des rôles',
      delete: 'Supprimer des rôles',
    },
    activity: {
      read: 'Voir le journal d’activité sécurité (audit, filtres IP)',
    },
  },
} as const;

export const frCommon = {
  save: 'Enregistrer',
  cancel: 'Annuler',
  edit: 'Modifier',
  delete: 'Supprimer',
  saving: 'Enregistrement…',
  empty_placeholder: '—',
  loading: 'Chargement…',
  list_loading_title: 'Chargement des données…',
  list_loading_hint:
    'Sur un réseau lent, cela peut prendre un instant. Merci de votre patience.',
  filter: 'Filtrer',
  clear: 'Effacer',
  all: 'Tous',
  prev: 'Précédent',
  next: 'Suivant',
  remove: 'Retirer',
  collapse: 'Réduire',
  expand: 'Développer',
  language: 'Langue',
  currency: 'Devise',
} as const;

export const frEmployee = {
  sidebar_profile: 'Profil',
  sidebar_team: 'Équipe',
  sidebar_security: 'Sécurité',
  title: 'Profil d’équipe',
  subtitle:
    'Gérez les informations de profil de votre personnel utilisées dans le back-office.',
  sign_in_required: 'Veuillez vous connecter pour afficher votre profil.',
  profile_section_title: 'Profil du membre du personnel',
  profile_section_subtitle:
    'Comment vos informations apparaissent dans le back-office.',
  field_full_name: 'Nom complet',
  field_role_title: 'Rôle / titre',
  field_phone: 'Téléphone',
  edit_button: 'Modifier',
  save_button: 'Enregistrer les modifications',
  saving_label: 'Enregistrement…',
  cancel_button: 'Annuler',
  readonly_name_label: 'Nom',
  readonly_role_label: 'Rôle / titre',
  readonly_phone_label: 'Téléphone',
  not_set: 'Non renseigné',
  load_error: 'Impossible de charger le profil.',
  save_success: 'Profil mis à jour avec succès.',
  save_error: 'Impossible d’enregistrer le profil.',
  account_email_label: 'E-mail du compte',
  account_role_label: 'Rôle',
  security_section_title: 'Sécurité',
  current_password_label: 'Mot de passe actuel',
  new_password_label: 'Nouveau mot de passe',
  confirm_password_label: 'Confirmez le nouveau mot de passe',
  password_mismatch: 'Les mots de passe ne correspondent pas.',
  password_save_button: 'Mettre à jour le mot de passe',
  password_saving_label: 'Mise à jour…',
  password_change_success: 'Mot de passe mis à jour avec succès.',
  password_change_error: 'Impossible de modifier le mot de passe.',
  password_open_button: 'Changer le mot de passe',
} as const;

export const frEmployeeInvite = {
  title: 'Compléter votre invitation',
  subtitle:
    'Définissez un mot de passe pour votre compte employé Lewouhmart. Lors des prochaines connexions, un code MFA sera envoyé à votre e-mail.',
  invalid_link:
    'Ce lien d’invitation est invalide. Veuillez utiliser le lien reçu par e-mail.',
  field_password_label: 'Choisissez un mot de passe',
  field_password_confirm_label: 'Confirmez le mot de passe',
  password_mismatch: 'Les mots de passe ne correspondent pas.',
  suggest_password: 'Suggérer un mot de passe sécurisé',
  saving_label: 'Enregistrement…',
  save_button: 'Enregistrer le mot de passe',
  back_to_signin: 'Retour à la connexion',
  error_generic: 'Impossible de terminer l’invitation.',
  success_message:
    'Votre mot de passe a été défini. Vous pouvez maintenant vous connecter.',
} as const;


